var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6875 0C7.23978 0 7.6875 0.447715 7.6875 1L7.6875 7.11704L8.82414 5.98039C9.21467 5.58987 9.84783 5.58987 10.2384 5.98039C10.6289 6.37092 10.6289 7.00408 10.2384 7.39461L7.39461 10.2384L6.6875 10.9455L5.98039 10.2384L3.13664 7.39461C2.74612 7.00408 2.74612 6.37092 3.13664 5.98039C3.52717 5.58987 4.16033 5.58987 4.55086 5.98039L5.6875 7.11704L5.6875 1C5.6875 0.447715 6.13522 0 6.6875 0ZM1 8.9375C1.55228 8.9375 2 9.38521 2 9.9375V11.375H11.375V9.9375C11.375 9.38521 11.8227 8.9375 12.375 8.9375C12.9273 8.9375 13.375 9.38521 13.375 9.9375V12.375V13.375H12.375H1H0V12.375V9.9375C0 9.38521 0.447715 8.9375 1 8.9375Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a3249323.svg";
export { ForwardRef as ReactComponent };